import React from "react";
import { useNavigate } from "react-router";
import { fetchEpiCapture } from "../../lib/assistantApi.js";
import EpiAvatar from "./EpiAvatar.jsx";
import { epiArrowPath } from "./epiAnswerBlocks.js";

// Lumi assombrit l'écran sauf l'élément montré, et une flèche dorée part de sa fenêtre jusqu'à lui.
export function EpiPointer({ panelRef, replay, target }) {
  const [geometry, setGeometry] = React.useState(null);
  React.useLayoutEffect(() => {
    target.scrollIntoView({ block: "nearest", inline: "nearest" });
    const measure = () => {
      const panel = panelRef.current?.getBoundingClientRect();
      const spot = target.getBoundingClientRect();
      if (panel) setGeometry({ path: epiArrowPath(panel, spot), spot });
    };
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", measure, true);
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", measure, true);
    };
  }, [panelRef, target]);
  if (!geometry) return null;
  const { path, spot } = geometry;
  return (
    <div aria-hidden="true" className="epi-pointer" key={replay}>
      <div className="epi-spot" style={{ left: spot.left - 6, top: spot.top - 6, width: spot.width + 12, height: spot.height + 12 }} />
      <svg className="epi-arrow">
        <defs>
          <marker id="epi-arrow-head" markerHeight="4.5" markerWidth="4.5" orient="auto" refX="7" refY="5" viewBox="0 0 10 10">
            <path d="M0,0 L10,5 L0,10 z" fill="#e3a83f" stroke="#3b2a08" strokeWidth=".8" />
          </marker>
        </defs>
        <path className="epi-arrow__shade" d={path} />
        <path className="epi-arrow__line" d={path} markerEnd="url(#epi-arrow-head)" />
      </svg>
    </div>
  );
}

export function EpiShownOnScreen({ label, onReplay }) {
  return (
    <div className="epi-shown">
      <EpiAvatar size={20} />
      <span>Montré sur votre écran : <b>{label}</b></span>
      <button className="epi-action" onClick={onReplay} type="button">Revoir</button>
    </div>
  );
}

// Élément absent de la page : capture fléchée du Guide, et un bouton pour ouvrir la bonne page.
export function EpiCapture({ elsewhere, onClose, show }) {
  const navigate = useNavigate();
  const [source, setSource] = React.useState("");
  React.useEffect(() => {
    if (!show.image) return undefined;
    let active = true;
    let url = "";
    fetchEpiCapture(show.image).then((objectUrl) => {
      url = objectUrl;
      if (active) setSource(objectUrl);
      else URL.revokeObjectURL(objectUrl);
    }).catch(() => {});
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [show.image]);
  if (!source && !elsewhere) return null;
  return (
    <figure className="epi-figure">
      {source ? <img alt={`Capture du Guide : ${show.label}, ${show.where}`} src={source} /> : null}
      <figcaption>
        {source ? <span>Capture du Guide : <b>{show.where}</b></span> : <span />}
        {elsewhere ? (
          <button className="epi-go" onClick={() => { onClose(); navigate(show.page); }} type="button">Ouvrir {show.where}</button>
        ) : null}
      </figcaption>
    </figure>
  );
}
